<template>
  <div class="double-choice-recommend-list" ref="jobRairRecommendList">
    <div class="rd-header">
      <div class="rd-header-left" @click="handleBackHall">推荐大厅</div>
      <div class="rd-header-title">双选会推荐</div>
    </div>
    <div class="double-choice-recommend-container">
      <double-choice-card v-for="item in showDoubleChoiceList" :key="item.id" :info="item.info"></double-choice-card>
    </div>
    <div class="baseline" v-show="baselineFlag"></div>
  </div>
</template>

<script>
import DoubleChoiceCard from '@/components/rd/DoubleChoiceCard'
import {
  getRecommendInfoById,
  getJobFairDetail
} from '@/api/rd.js'
export default {
  components: {
    DoubleChoiceCard
  },
  data () {
    return {
      doubleChoiceList: [],
      showDoubleChoiceList: [],
      baselineFlag: false
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList () {
      let id = this.$route.query.id
      const res = await getRecommendInfoById({ id: id })
      if (res.data.success) {
        const data = res.data.data
        // 获取双选会详情
        this.doubleChoiceList = data.recommendJobFairList
        for (let i = 0; i < this.doubleChoiceList.length; i++) {
          const jobRes = await getJobFairDetail({ jobFairId: this.doubleChoiceList[i].jobFairId, id: this.$route.query.id })
          this.$set(this.doubleChoiceList[i], 'info', jobRes.data.data)
          if (jobRes.data.data) {
            this.showDoubleChoiceList.push(this.doubleChoiceList[i])
          }
        }
        this.$nextTick(() => {
          const jobRairRecommendList = this.$refs.jobRairRecommendList
          if (jobRairRecommendList.scrollHeight - jobRairRecommendList.offsetHeight > 0) {
            this.baselineFlag = true
          }
        })
      } else {
        this.$notify({
          type: "warning",
          message: res.data.apiErrorMessage,
          duration: 3 * 1000,
        });
        if (res.data.errorCode === 421) {
          this.$router.push({
            name: '404'
          })
        }
      }
    },
    handleBackHall () {
      this.$router.push(
        {
          name: 'RecommendHall',
          query: {
            companyNumber: this.$route.query.companyNumber,
            id: this.$route.query.id
          }
        }
      )
    },
  }
}
</script>

<style lang="less" scoped>
.double-choice-recommend-list {
  padding-top: 55px;
  height: calc(100% - 55px);
  overflow-y: auto;
  background-color: #f3f4f7;

  .double-choice-recommend-container {
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
